<dz-modal-header [hasBackdrop]="true">
	<h1 class="dz-text-28-extra-bold" dcrHTMLKey="UNSUPPORTED_SECURITIES_MODAL_TITLE">Unsupported Securities</h1>
</dz-modal-header>

<dz-modal-content>
	<p dcrHTMLKey="UNSUPPORTED_SECURITIES_MODAL_BODY_INFO">The following portfolios contain unsupported securities.</p>

	<ul class="dirty-portfolio-list">
		<li *ngFor="let portfolioName of dirtyPortfolioNames">
			{{ portfolioName }}
		</li>
	</ul>

	<p dcrHTMLKey="UNSUPPORTED_SECURITIES_MODAL_BODY_INSTRUCTION">
		Please search for suitable replacements or replace them with cash. You can also choose to remove any portfolio from this analysis.
	</p>
</dz-modal-content>

<dz-modal-actions [hasBackdrop]="true">
	<button
		dz-button
		color="secondary"
		(click)="onCancel()"
		[dcrHTMLKey]="'UNSUPPORTED_SECURITIES_MODAL_' + (holdingsResolutionState.isRefreshFlow ? 'CANCEL' : 'BACK')"
		disable-tracking
	>
		Back
	</button>
	<button dz-button (click)="onContinue()" dcrHTMLKey="UNSUPPORTED_SECURITIES_MODAL_CONTINUE" custom-tracking track-event="dirty-portfolio-popup:continue">Continue</button>
</dz-modal-actions>
